/* Quick-add + färgswatchar på produktkort.
   Laddas i layout/theme.liquid:
     <script src="{{ 'quick-add.js' | asset_url }}" defer></script>

   Två saker händer här:

   1. Färgswatcharna i kortet (temats egna .product-block-options__item) byter
      kortets bild, skriver om länken till rätt variant och kommer ihåg vilken
      färg som valts. Temats egen hanterare i main.js letar upp variantbilden
      bland kortets renderade bilder, men kortet renderar bara en bild när
      "visa andra bilden vid hover" är avslagen. Den bommar därför alltid och
      avbryter innan den hinner göra något. Vi byter i stället src direkt på den
      aktiva bilden, vilket inte kräver att bilden finns i DOM sedan tidigare.

   2. Kundvagnsikonen på prisraden. Har produkten flera storlekar öppnas ett
      bottom sheet där storleken väljs, filtrerat på kortets valda färg.

   Allt är delegerat från document, så korten överlever att appen
   Variants as Separate Products bygger om rutnätet efter sidladdning. */

(function () {
  var TOAST_MS = 3200;
  var CARD = '.product-block';
  var SWATCH = '.product-block-options__item';

  function cardOf(node) {
    return node.closest(CARD);
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Framkallar övergången genom att tvinga fram en layout innan klassen sätts.
     requestAnimationFrame duger inte: den pausas i bakgrundsflikar, och då blir
     panelen kvar utanför skärmen fast den ligger i DOM. */
  function reveal(el, className) {
    void el.offsetHeight;
    el.classList.add(className);
  }

  /* ---------- Toast ---------- */

  function toast(message, isError) {
    var existing = document.querySelector('.qa-toast');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.className = 'qa-toast' + (isError ? ' qa-toast--error' : '');
    el.setAttribute('role', 'status');
    el.innerHTML = '<span></span>';
    el.querySelector('span').textContent = message;

    if (!isError) {
      var link = document.createElement('a');
      link.href = routeRoot() + 'cart';
      link.textContent = 'Till varukorg';
      el.appendChild(link);
    }

    document.body.appendChild(el);
    reveal(el, 'is-in');
    setTimeout(function () {
      el.classList.remove('is-in');
      setTimeout(function () { el.remove(); }, 250);
    }, TOAST_MS);
  }

  /* ---------- Lägg i varukorg ---------- */

  /* Använder temats eget mönster: posta till cart/add.js med de sektioner som
     visar varukorgen, och låt dem rita om sig själva. Då hålls antalet i
     headern och innehållet i cart drawer i synk utan att vi räknar själva.
     Drawern öppnas medvetet inte - kunden ska bli kvar i rutnätet. */
  function addToCart(variantId, label, button) {
    if (button) {
      button.disabled = true;
      button.dataset.loading = 'true';
    }

    var sections = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(function (el) { return el && el.dataset.sectionId && typeof el.updateFromCartChange === 'function'; });

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (sections.length) {
      body.append('sections', sections.map(function (el) { return el.dataset.sectionId; }).join(','));
      body.append('sections_url', window.location.pathname);
    }

    var url = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || routeRoot() + 'cart/add.js';

    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) {
          throw new Error(r.data.description || r.data.message || 'Kunde inte lägga i varukorgen');
        }

        if (r.data.sections) {
          sections.forEach(function (el) {
            var html = r.data.sections[el.dataset.sectionId];
            if (html) el.updateFromCartChange(html);
          });
        }
        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: r.data.variant_id }
        }));

        toast('Tillagd — ' + label);
        if (button) {
          button.classList.add('is-done');
          setTimeout(function () { button.classList.remove('is-done'); }, 1600);
        }
        return true;
      })
      .catch(function (err) {
        toast(err.message, true);
        return false;
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          delete button.dataset.loading;
        }
      });
  }

  /* ---------- Färgswatch ---------- */

  /* Mallen med storlekar. Färgkort för samma produkt delar en mall, som bara
     ligger i det första kortet (snippets/product-color-cards), annars upprepas
     hela produktens varianter i varje kort. */
  function templateFor(root) {
    if (!root) return null;
    var own = root.querySelector('[data-quick-add-template]');
    if (own) return own;
    var id = root.dataset.quickAddProduct;
    var legacy = id ? document.querySelector('[data-quick-add-product="' + id + '"] [data-quick-add-template]') : null;
    if (legacy) return legacy;
    return buildTemplate(root, id);
  }

  /* Panelen byggs från JSON i snippets/quick-add.liquid första gången en
     produkt öppnas, och sparas sedan per produkt. Markupen är densamma som den
     tidigare <template> i varje kort. */
  var builtTemplates = {};

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildTemplate(root, id) {
    if (id && builtTemplates[id]) return builtTemplates[id];
    var script = root.querySelector('[data-quick-add-data]') ||
      (id ? document.querySelector('[data-quick-add-product="' + id + '"] [data-quick-add-data]') : null);
    if (!script) return null;

    var data;
    try { data = JSON.parse(script.textContent); } catch (e) { return null; }

    var sizes = (data.v || []).map(function (v) {
      var available = v[3] === 1;
      return '<button class="qa-size' + (available ? '' : ' qa-size--out') + '" type="button" data-qa-size data-variant-id="' + v[0] +
        '" data-variant-color="' + escapeHtml(v[2]) + '"' + (available ? '' : ' disabled aria-disabled="true"') + '>' + escapeHtml(v[1]) + '</button>';
    }).join('');

    var html =
      '<div class="qa-sheet" role="dialog" aria-modal="true" aria-label="Välj storlek för ' + escapeHtml(data.title) + '">' +
        '<div class="qa-sheet__scrim" data-qa-close></div>' +
        '<div class="qa-sheet__panel">' +
          '<div class="qa-sheet__grip"></div>' +
          '<div class="qa-sheet__head">' +
            (data.thumb ? '<img class="qa-sheet__thumb" src="' + escapeHtml(data.thumb) + '" alt="" width="62" height="78" loading="lazy" data-qa-thumb>' : '') +
            '<div class="qa-sheet__meta">' +
              '<p class="qa-sheet__title">' + escapeHtml(data.title) + '</p>' +
              '<p class="qa-sheet__price">' + escapeHtml(data.price) + '</p>' +
              '<p class="qa-sheet__color" data-qa-color hidden></p>' +
            '</div>' +
            '<button class="qa-sheet__close" type="button" data-qa-close aria-label="' + escapeHtml(data.close) + '">&times;</button>' +
          '</div>' +
          '<div class="qa-sheet__label"><span>Välj storlek</span></div>' +
          '<div class="qa-sheet__sizes">' + sizes + '</div>' +
          '<p class="qa-sheet__note" data-qa-note hidden></p>' +
          '<button class="qa-sheet__cta" type="button" data-qa-submit disabled>Välj storlek</button>' +
        '</div>' +
      '</div>';

    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    if (id) builtTemplates[id] = tpl;
    return tpl;
  }

  function activeSwatch(card) {
    return card ? card.querySelector(SWATCH + '.is-selected') : null;
  }

  function fileName(url) {
    return (url || '').split('/').pop().split('?')[0];
  }

  function swatchByValue(card, value) {
    if (!card || !value) return null;
    var all = card.querySelectorAll(SWATCH);
    for (var i = 0; i < all.length; i++) {
      if (all[i].dataset.optionItem === value) return all[i];
    }
    return null;
  }

  /* Vilken färg kortet står på, i fallande tillförlitlighet:
       1. swatchen kunden klickat på,
       2. varianten kortet är låst till (temats färgkort, tidigare appen Variator),
       3. bilden kortet faktiskt visar, matchad mot swatcharnas variantbilder,
       4. produktens första tillgängliga variant, från Liquid.

     Steg 3 före steg 4 är inte godtyckligt. På en mätning av startsidan pekade
     bilden rätt på 7 av 8 flerfärgade kort, medan första tillgängliga variant
     bara stämde på 5 - den ordningen följer inte alltid bilduppsättningen.

     Returnerar även swatchen, så miniatyren i sheeten kan visa exakt den färg
     som står i texten i stället för något annat plagg. */
  function resolveColor(card, root) {
    var chosen = activeSwatch(card);
    if (chosen) return { name: chosen.dataset.optionItem || '', swatch: chosen };

    // data-card-variant-id sätts av snippets/product-color-cards (temats egna
    // färgkort), data-eosh-variant-id av den tidigare appen Variator.
    var appVariant = card && (card.dataset.cardVariantId || card.dataset.eoshVariantId);
    if (appVariant && root) {
      var tpl = templateFor(root);
      var match = tpl && tpl.content.querySelector('[data-variant-id="' + appVariant + '"]');
      if (match) {
        var appColor = match.dataset.variantColor || '';
        return { name: appColor, swatch: swatchByValue(card, appColor) };
      }
    }

    var img = card && card.querySelector('.product-block__image--active img');
    var shown = fileName(img && (img.currentSrc || img.getAttribute('src')));
    if (shown) {
      var all = card.querySelectorAll(SWATCH);
      for (var i = 0; i < all.length; i++) {
        if (fileName(all[i].dataset.mediaSrc) === shown) {
          return { name: all[i].dataset.optionItem || '', swatch: all[i] };
        }
      }
    }

    var fallback = (root && root.dataset.defaultColor) || '';
    return { name: fallback, swatch: swatchByValue(card, fallback) };
  }

  // srcset byggs ur data-media-src (800 px) i stället för att skickas med
  // varje swatch i HTML:en, som annars upprepas för alla färgkort i rutnätet.
  function srcsetFor(swatch) {
    if (swatch.dataset.mediaSrcset) return swatch.dataset.mediaSrcset;
    var src = swatch.dataset.mediaSrc;
    if (!src || src.indexOf('width=800') === -1) return '';
    return src.replace('width=800', 'width=400') + ' 400w, ' + src + ' 800w';
  }

  function swapImage(card, swatch) {
    var src = swatch.dataset.mediaSrc;
    if (!src) return;
    var srcset = srcsetFor(swatch);

    var img = card.querySelector('.product-block__image--active img') || card.querySelector('.product-block__image img');
    if (!img) return;

    // Förladda innan bytet, annars blinkar kortet tomt och rutnätet hoppar.
    img.classList.add('is-swapping');
    var next = new Image();
    next.onload = function () {
      img.removeAttribute('data-manual-src');
      img.removeAttribute('data-manual-srcset');
      img.removeAttribute('data-defer-src');
      img.removeAttribute('data-defer-srcset');
      img.src = src;
      if (srcset) {
        img.srcset = srcset;
      } else {
        img.removeAttribute('srcset');
      }
      if (swatch.dataset.mediaAlt) img.alt = swatch.dataset.mediaAlt;
      img.classList.remove('is-swapping');
    };
    next.onerror = function () { img.classList.remove('is-swapping'); };
    if (srcset) next.srcset = srcset;
    next.src = src;
  }

  function selectSwatch(swatch, moveFocus) {
    var card = cardOf(swatch);
    var group = swatch.closest('.product-block-options');
    if (!card || !group) return;

    group.querySelectorAll(SWATCH).forEach(function (el) {
      var on = el === swatch;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.setAttribute('tabindex', on ? '0' : '-1');
    });

    swapImage(card, swatch);

    if (swatch.dataset.variantId) {
      card.querySelectorAll('a.product-link, a.quickbuy-toggle').forEach(function (link) {
        var base = (link.getAttribute('href') || '').split('?')[0];
        if (!base) return;
        link.setAttribute('href', base + '?variant=' + swatch.dataset.variantId);
        link.setAttribute('rel', 'nofollow');
      });
    }

    if (moveFocus) swatch.focus();
  }

  /* Temats swatchar är span-element utan roller. Sätts här i stället för i
     Liquid, så att kort som appen renderar om också blir tangentbordsstyrda. */
  function upgradeSwatches(scope) {
    (scope || document).querySelectorAll('.product-block-options').forEach(function (group) {
      if (group.dataset.qaUpgraded) return;
      group.dataset.qaUpgraded = 'true';
      group.setAttribute('role', 'radiogroup');
      if (group.dataset.optionName) group.setAttribute('aria-label', group.dataset.optionName);

      var items = group.querySelectorAll(SWATCH);
      items.forEach(function (el, i) {
        el.setAttribute('role', 'radio');
        el.setAttribute('aria-checked', 'false');
        el.setAttribute('tabindex', i === 0 ? '0' : '-1');
        if (!el.getAttribute('aria-label') && el.dataset.optionItem) {
          el.setAttribute('aria-label', el.dataset.optionItem);
        }
      });
    });
  }

  /* ---------- Bottom sheet ---------- */

  var openSheetEl = null;

  function openSheet(root, opener) {
    if (openSheetEl) return;

    var tpl = templateFor(root);
    if (!tpl) return;

    var card = cardOf(root);
    var sheet = tpl.content.firstElementChild.cloneNode(true);
    var cta = sheet.querySelector('[data-qa-submit]');
    var title = root.dataset.productTitle || '';
    var selected = null;

    // Vald färg följer med in, så kunden inte behöver välja färg två gånger.
    var resolved = resolveColor(card, root);
    var color = resolved.name;
    if (color) {
      var colorNode = sheet.querySelector('[data-qa-color]');
      if (colorNode) {
        colorNode.textContent = 'Färg: ' + color;
        colorNode.hidden = false;
      }
      // Filtrera bara om färgen faktiskt matchar något. Skulle namnen gå isär
      // ska sheeten visa alla storlekar, inte bli tom och tyst.
      var matching = Array.prototype.filter.call(
        sheet.querySelectorAll('[data-qa-size]'),
        function (b) { return b.dataset.variantColor === color; }
      );
      if (matching.length) {
        sheet.querySelectorAll('[data-qa-size]').forEach(function (b) {
          if (b.dataset.variantColor !== color) b.remove();
        });
      }
    }

    // Miniatyren ska visa den färg som står i texten. Går färgen inte att knyta
    // till en swatch visas kortets bild, så sheeten aldrig hittar på ett plagg.
    var thumb = sheet.querySelector('[data-qa-thumb]');
    if (thumb) {
      var cardImage = card && card.querySelector('.product-block__image--active img');
      if (resolved.swatch && resolved.swatch.dataset.mediaSrc) {
        thumb.src = resolved.swatch.dataset.mediaSrc;
      } else if (cardImage && (cardImage.currentSrc || cardImage.getAttribute('src'))) {
        thumb.src = cardImage.currentSrc || cardImage.getAttribute('src');
      }
      thumb.removeAttribute('srcset');
    }

    var sizes = sheet.querySelectorAll('[data-qa-size]');
    if (!sizes.length) return;

    // Slutsålda storlekar står kvar utgråade, med besked om vad som är slut.
    var soldOut = Array.prototype.filter.call(sizes, function (b) { return b.disabled; })
      .map(function (b) { return b.textContent.trim(); });
    if (soldOut.length) {
      var note = sheet.querySelector('[data-qa-note]');
      if (note) {
        note.innerHTML = '';
        note.appendChild(document.createTextNode(
          (soldOut.length > 1 ? 'Slut i storlek ' : 'Slut i storlek ') + soldOut.join(', ') + '. '
        ));
        var link = document.createElement('a');
        link.href = root.dataset.productUrl || '#';
        link.textContent = 'Bevaka storleken';
        note.appendChild(link);
        note.appendChild(document.createTextNode(' så hör vi av oss.'));
        note.hidden = false;
      }
    }

    function pick(btn) {
      sizes.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selected = { id: btn.dataset.variantId, label: btn.textContent.trim() };
      cta.disabled = false;
      cta.textContent = 'Lägg i varukorg · ' + selected.label;
    }

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function () { pick(btn); });
    });

    // Finns bara en storlek kvar efter färgfiltret är valet redan gjort.
    var inStock = Array.prototype.filter.call(sizes, function (b) { return !b.disabled; });
    if (inStock.length === 1) pick(inStock[0]);

    function close() {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('qa-scroll-locked');
      document.removeEventListener('keydown', onKey);
      openSheetEl = null;
      if (opener) opener.setAttribute('aria-expanded', 'false');
      setTimeout(function () { sheet.remove(); }, 300);
      if (opener && opener.focus) opener.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = sheet.querySelectorAll('button:not([disabled]), a[href]');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    sheet.querySelectorAll('[data-qa-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', onKey);

    cta.addEventListener('click', function () {
      if (!selected) return;
      addToCart(selected.id, title + ', ' + selected.label, cta).then(function (ok) {
        if (ok) close();
      });
    });

    document.body.appendChild(sheet);
    openSheetEl = sheet;
    document.documentElement.classList.add('qa-scroll-locked');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    reveal(sheet, 'is-open');

    var focusTarget = inStock[0] || sheet.querySelector('[data-qa-close]');
    if (focusTarget) focusTarget.focus();
  }

  /* ---------- Delegering ---------- */

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest(SWATCH);
    if (swatch && swatch.closest(CARD)) {
      event.preventDefault();
      event.stopPropagation();
      selectSwatch(swatch);
      return;
    }

    var direct = event.target.closest('[data-quick-add-direct]');
    if (direct) {
      event.preventDefault();
      var root = direct.closest('[data-quick-add]');
      addToCart(direct.dataset.variantId, (root && root.dataset.productTitle) || '', direct);
      return;
    }

    var opener = event.target.closest('[data-quick-add-open]');
    if (opener) {
      event.preventDefault();
      openSheet(opener.closest('[data-quick-add]'), opener);
    }
  });

  document.addEventListener('keydown', function (event) {
    var swatch = event.target.closest ? event.target.closest(SWATCH) : null;
    if (!swatch) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      selectSwatch(swatch);
      return;
    }
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

    event.preventDefault();
    var all = Array.prototype.slice.call(swatch.closest('.product-block-options').querySelectorAll(SWATCH));
    var step = event.key === 'ArrowRight' ? 1 : -1;
    var next = all[(all.indexOf(swatch) + step + all.length) % all.length];
    selectSwatch(next, true);
  });

  upgradeSwatches();

  // Filter, sidbyte och varukorgslådan byter ut kort efter sidladdning. Bara
  // tillagda element som innehåller swatchar uppgraderas, så att DOM-ändringar
  // som inte rör korten (t.ex. Google Translate på .com) inte söker igenom hela
  // dokumentet varje gång.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('.product-block-options')) {
            upgradeSwatches(node.parentNode);
          } else if (node.firstElementChild && node.querySelector('.product-block-options')) {
            upgradeSwatches(node);
          }
        });
      });
    }).observe(document.documentElement, { subtree: true, childList: true });
  }
})();
